var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_32899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1045 7.07812C10.8601 7.07812 10.6621 7.27732 10.6621 7.52309V15.9329C10.6621 16.1785 10.8601 16.3778 11.1045 16.3778C11.3488 16.3778 11.5468 16.1785 11.5468 15.9329V7.52309C11.5468 7.27732 11.3488 7.07812 11.1045 7.07812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88572 7.07812C5.64139 7.07812 5.44336 7.27732 5.44336 7.52309V15.9329C5.44336 16.1785 5.64139 16.3778 5.88572 16.3778C6.13006 16.3778 6.32808 16.1785 6.32808 15.9329V7.52309C6.32808 7.27732 6.13006 7.07812 5.88572 7.07812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08255 5.84787V16.8108C2.08255 17.4588 2.31876 18.0673 2.7314 18.5039C3.14214 18.9418 3.71376 19.1903 4.31198 19.1913H12.6816C13.28 19.1903 13.8516 18.9418 14.2622 18.5039C14.6748 18.0673 14.911 17.4588 14.911 16.8108V5.84787C15.7313 5.62887 16.2628 4.83176 16.1531 3.98511C16.0432 3.13864 15.3263 2.50544 14.4775 2.50527H12.2126V1.94907C12.2152 1.48133 12.0314 1.0322 11.7022 0.701781C11.373 0.371535 10.9258 0.187641 10.4608 0.191465H6.53277C6.06778 0.187641 5.62058 0.371535 5.2914 0.701781C4.96222 1.0322 4.77836 1.48133 4.78095 1.94907V2.50527H2.5161C1.66732 2.50544 0.950382 3.13864 0.840483 3.98511C0.730756 4.83176 1.26228 5.62887 2.08255 5.84787ZM12.6816 18.3014H4.31198C3.55565 18.3014 2.96727 17.6479 2.96727 16.8108V5.88698H14.0263V16.8108C14.0263 17.6479 13.4379 18.3014 12.6816 18.3014ZM5.66568 1.94907C5.66274 1.71737 5.75329 1.49437 5.91675 1.33081C6.08005 1.16725 6.30226 1.07739 6.53277 1.08139H10.4608C10.6913 1.07739 10.9135 1.16725 11.0768 1.33081C11.2403 1.4942 11.3308 1.71737 11.3279 1.94907V2.50527H5.66568V1.94907ZM2.5161 3.39519H14.4775C14.9173 3.39519 15.2737 3.75377 15.2737 4.19612C15.2737 4.63848 14.9173 4.99706 14.4775 4.99706H2.5161C2.07633 4.99706 1.71985 4.63848 1.71985 4.19612C1.71985 3.75377 2.07633 3.39519 2.5161 3.39519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4951 7.07812C8.25076 7.07812 8.05273 7.27732 8.05273 7.52309V15.9329C8.05273 16.1785 8.25076 16.3778 8.4951 16.3778C8.73943 16.3778 8.93746 16.1785 8.93746 15.9329V7.52309C8.93746 7.27732 8.73943 7.07812 8.4951 7.07812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_32899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 19,
    fill: "white",
    transform: "translate(0 0.191406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.deeea3ddef5419ce645ad1ab75c92638.svg";
export { ForwardRef as ReactComponent };